"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableState = exports.CollectionModelDrawableStateMutator = void 0;
var id_1 = require("../../../id");
var label_drawable_1 = require("./label.drawable");
var line_drawable_1 = require("./line.drawable");
var line_point_drawable_1 = require("./line.point.drawable");
var marker_drawable_1 = require("./marker.drawable");
var marker_offset_drawable_1 = require("./marker.offset.drawable");
var mask_drawable_1 = require("./mask.drawable");
function makeDrawableState(tag, id, parentId) {
    switch (tag) {
        case 'offset':
            return marker_offset_drawable_1.CollectionModelDrawableMarkerOffset.state();
        case 'marker':
            return marker_drawable_1.CollectionModelDrawableMarker.state(id, parentId);
        case 'label':
            return label_drawable_1.CollectionModelDrawableLabel.state(id, parentId);
        case 'line':
            return line_drawable_1.CollectionModelDrawableLine.state(id, parentId);
        case 'line-point':
            return line_point_drawable_1.CollectionModelDrawableLinePoint.state(id, parentId);
        case 'mask':
            return mask_drawable_1.CollectionModelDrawableMask.state(id);
        default:
            throw new Error("Unknown marker type: \"".concat(tag, "\""));
    }
}
var CollectionModelDrawableStateMutator = /** @class */ (function () {
    function CollectionModelDrawableStateMutator(state) {
        this.state = state;
    }
    CollectionModelDrawableStateMutator.prototype.getState = function () {
        var collectionState = this.state.collection.state;
        var captureDrawableKey = CollectionModelDrawableState.captureDrawableId(this.state.captureId);
        var state = collectionState.getFieldValue(captureDrawableKey);
        if (state == null) {
            return [];
        }
        return state.slice();
    };
    CollectionModelDrawableStateMutator.prototype.setState = function (state) {
        var collectionState = this.state.collection.state;
        var captureDrawableKey = CollectionModelDrawableState.captureDrawableId(this.state.captureId);
        collectionState.setFieldValue(captureDrawableKey, state);
    };
    CollectionModelDrawableStateMutator.prototype.create = function (tag, id, parentId) {
        if (id === void 0) { id = id_1.IkeId.generate(); }
        if (parentId === void 0) { parentId = null; }
        var state = makeDrawableState(tag, id, parentId);
        return this.createWithState(state);
    };
    CollectionModelDrawableStateMutator.prototype.link = function (drawable, field) {
        var label = drawable.label;
        label.Mutator.link(field);
        field.Mutator.drawable(drawable);
    };
    CollectionModelDrawableStateMutator.prototype.unlink = function (drawable, field) {
        var label = drawable.label;
        label.Mutator.unlink(field.id);
        var drawableIndex = this.getState().indexOf(drawable.id);
        if (label.links.length === 0 && drawableIndex > -1) {
            this.remove(drawable);
        }
    };
    CollectionModelDrawableStateMutator.prototype.remove = function (drawable) {
        var drawableIds = this.getState();
        var index = drawableIds.indexOf(drawable.id);
        if (index === -1) {
            throw new Error("Cannot remove drawable. Instance \"".concat(drawable.id, "\" is missing from capture \"").concat(this.state.captureId, "\""));
        }
        drawableIds.splice(index, 1);
        this.setState(drawableIds);
        if (marker_drawable_1.CollectionModelDrawableMarker.isMarker(drawable) || line_drawable_1.CollectionModelDrawableLine.isLine(drawable)) {
            var label = drawable.label;
            for (var _i = 0, _a = label.links; _i < _a.length; _i++) {
                var link = _a[_i];
                link.Mutator.unlink();
            }
            this.remove(label);
        }
        if (marker_offset_drawable_1.CollectionModelDrawableMarkerOffset.isBaseOffset(drawable)) {
            this.remove(drawable.label);
        }
        delete this.state.drawables[drawable.id];
        drawable.Mutator.destroyState();
    };
    CollectionModelDrawableStateMutator.prototype.clear = function () {
        var drawables = this.state.values();
        for (var _i = 0, drawables_1 = drawables; _i < drawables_1.length; _i++) {
            var drawable = drawables_1[_i];
            var drawableIds = this.getState();
            var index = drawableIds.indexOf(drawable.id);
            if (index === -1) {
                continue;
            }
            this.remove(drawable);
        }
    };
    CollectionModelDrawableStateMutator.prototype.copy = function (from) {
        var newDrawableId = this.create(from.tag);
        var newDrawable = this.state.getDrawable(newDrawableId);
        if (marker_drawable_1.CollectionModelDrawableMarker.isMarker(newDrawable) && marker_drawable_1.CollectionModelDrawableMarker.isMarker(from)) {
            newDrawable.Mutator.copy(from);
        }
        return newDrawableId;
    };
    CollectionModelDrawableStateMutator.prototype.createWithState = function (state) {
        var collectionState = this.state.collection.state;
        var captureId = this.state.captureId;
        var stateId = CollectionModelDrawableState.drawableId(captureId, state.id);
        if (collectionState.fields.get(stateId) != null) {
            throw new Error("Drawable \"".concat(stateId, "\" already exists"));
        }
        collectionState.setFieldValue(stateId, state);
        var drawableState = this.getState();
        drawableState.push(state.id);
        this.setState(drawableState);
        return state.id;
    };
    return CollectionModelDrawableStateMutator;
}());
exports.CollectionModelDrawableStateMutator = CollectionModelDrawableStateMutator;
var ID_PREFIX_DRAWABLE = 'd';
var ID_PREFIX_CAPTURE_DRAWABLE = 'dl';
var CollectionModelDrawableState = /** @class */ (function () {
    function CollectionModelDrawableState(collection, captureId) {
        this.Mutator = new CollectionModelDrawableStateMutator(this);
        this.id = id_1.IkeId.generate();
        this.drawables = {};
        this.collection = collection;
        this.captureId = captureId;
    }
    CollectionModelDrawableState.drawableId = function (captureId, drawableId) {
        return "".concat(ID_PREFIX_DRAWABLE, ":").concat(captureId, ":").concat(drawableId);
    };
    CollectionModelDrawableState.captureDrawableId = function (captureId) {
        return "".concat(ID_PREFIX_CAPTURE_DRAWABLE, ":").concat(captureId);
    };
    CollectionModelDrawableState.getCaptureDrawableId = function (key) {
        if (key.startsWith("".concat(ID_PREFIX_CAPTURE_DRAWABLE, ":"))) {
            return key.substr(3);
        }
        return null;
    };
    Object.defineProperty(CollectionModelDrawableState.prototype, "base", {
        /**
         * Returns the base drawable
         */
        get: function () {
            for (var _i = 0, _a = this.state; _i < _a.length; _i++) {
                var drawableId = _a[_i];
                var drawable = this.getDrawable(drawableId);
                if (marker_drawable_1.CollectionModelDrawableMarker.isBase(drawable)) {
                    return drawable;
                }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableState.prototype, "insightBase", {
        /**
         * Returns the base drawable, Only if it is an un-approved insight measurement
         */
        get: function () {
            // This should not trigger as we don't support insight bases made by the back end yet
            for (var _i = 0, _a = this.state; _i < _a.length; _i++) {
                var drawableId = _a[_i];
                var drawable = this.getDrawable(drawableId);
                if (marker_drawable_1.CollectionModelDrawableMarker.isBase(drawable) && drawable.isInsightMeasurement) {
                    return drawable;
                }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableState.prototype, "baseOffset", {
        get: function () {
            for (var _i = 0, _a = this.state; _i < _a.length; _i++) {
                var drawableId = _a[_i];
                var drawable = this.getDrawable(drawableId);
                if (marker_offset_drawable_1.CollectionModelDrawableMarkerOffset.isBaseOffset(drawable)) {
                    return drawable;
                }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableState.prototype, "insightBaseOffset", {
        /**
         * Returns the base offset drawable, Only if it is an un-approved insight measurement
         */
        get: function () {
            // This should not trigger as we don't support insight base offsets made by the back end yet
            for (var _i = 0, _a = this.state; _i < _a.length; _i++) {
                var drawableId = _a[_i];
                var drawable = this.getDrawable(drawableId);
                if (marker_offset_drawable_1.CollectionModelDrawableMarkerOffset.isBaseOffset(drawable) && drawable.isInsightMeasurement) {
                    return drawable;
                }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableState.prototype.hasDrawable = function (drawableId) {
        return this.state.indexOf(drawableId) > -1;
    };
    CollectionModelDrawableState.prototype.getDrawable = function (drawableId) {
        var drawable = this.drawables[drawableId];
        if (drawable == null) {
            var drawableState = this.collection.state.getFieldValue(CollectionModelDrawableState.drawableId(this.captureId, drawableId));
            if (drawableState == null || typeof drawableState !== 'object') {
                throw new Error("Cannot find drawable state for capture \"".concat(this.captureId, "\" and drawable \"").concat(drawableId, "\""));
            }
            if ('tag' in drawableState === false) {
                throw new Error("Capture ".concat(this.captureId, ":Drawable \"").concat(drawableId, "\" is missing tag"));
            }
            switch (drawableState.tag) {
                case 'marker':
                    drawable = new marker_drawable_1.CollectionModelDrawableMarker(this, drawableId, this.captureId);
                    break;
                case 'label':
                    drawable = new label_drawable_1.CollectionModelDrawableLabel(this, drawableId, this.captureId);
                    break;
                case 'line':
                    drawable = new line_drawable_1.CollectionModelDrawableLine(this, drawableId, this.captureId);
                    break;
                case 'line-point':
                    drawable = new line_point_drawable_1.CollectionModelDrawableLinePoint(this, drawableId, this.captureId);
                    break;
                case 'offset':
                    drawable = new marker_offset_drawable_1.CollectionModelDrawableMarkerOffset(this, drawableId, this.captureId);
                    break;
                case 'mask':
                    drawable = new mask_drawable_1.CollectionModelDrawableMask(this, drawableId, this.captureId);
                    break;
                default:
                    throw new Error("Capture ".concat(this.captureId, ":Unknown marker type: \"").concat(drawableState.tag, "\""));
            }
            this.drawables[drawableId] = drawable;
        }
        return drawable;
    };
    CollectionModelDrawableState.prototype.getAllDrawables = function () {
        var _this = this;
        return this.state.map(function (drawableId) { return _this.getDrawable(drawableId); });
    };
    CollectionModelDrawableState.prototype.values = function () {
        var output = [];
        for (var _i = 0, _a = this.state; _i < _a.length; _i++) {
            var drawableId = _a[_i];
            var drawable = this.getDrawable(drawableId);
            output.push(drawable);
        }
        return output;
    };
    CollectionModelDrawableState.prototype.hasMeasurements = function () {
        return this.state.length > 0;
    };
    CollectionModelDrawableState.prototype.hasUserMeasurements = function () {
        return this.getAllDrawables().some(function (drawable) { return drawable.isUserMeasurement; });
    };
    CollectionModelDrawableState.prototype.hasInsightDetections = function () {
        return this.getAllDrawables().some(function (drawable) { return drawable.isInsightMeasurement; });
    };
    Object.defineProperty(CollectionModelDrawableState.prototype, "capture", {
        get: function () {
            return this.collection.state.getCapture(this.captureId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableState.prototype, "state", {
        get: function () {
            return this.collection.state.getFieldValue(CollectionModelDrawableState.captureDrawableId(this.captureId)) || [];
        },
        enumerable: false,
        configurable: true
    });
    return CollectionModelDrawableState;
}());
exports.CollectionModelDrawableState = CollectionModelDrawableState;
//# sourceMappingURL=drawable.state.js.map